import styled from "styled-components";

export const HeaderStyled = styled.div`
  .top-header{
  margin:10px 30px;
  height:50px;
  align-items:center;
  display:flex;
  justify-content: space-between;
  }
  .logo-section{
  align-items:center;
  cursor: pointer;
  }
  .logo-section img{
    height: 5%;
    object-fit: cover;
    width: 70px;
  }
  .account-section{
  display:flex;
  align-items:center;
  gap:8px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  cursor: pointer;
  }
  .account-section .account-price{
   color:#E15089;
  }
  .allItemsSection{
  height:43px;
  align-items:center;
  } 
  .allItemsSection .row-item-secion{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin:0px 0px 0px 30px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  height:43px;
  }
  .row-item-secion .nav-link.active {
   background: #ff7218;
   color: #FFFFFF;
  }
   .row-item-secion .nav-link:hover{
    cursor: pointer;
   }
.allItemsSection .row-item-secion a{
 font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  color: #212121;
}
.tabs-section-inside-div{
  display:flex;
  width:max-content;
  }
  .tabs-section{
    display:block;
    overflow-x: scroll;
    overflow-y: hidden;
    scrollbar-width: none;

  }

  // mobile view styles

  @media screen and (max-width: 767px) {
 .top-header{
  margin:10px 16px;
 }
  .allItemsSection .row-item-secion{
  margin:0px 0px 0px 16px;
  }
}



`;
